module.exports = __webpack_public_path__ + "static/img/智能Agent签收，高效管理，智能守护，安全无忧.ceb8ad23.png";